import React, { createContext, useReducer, useEffect } from 'react';
import { getViewportWidth } from './utils';
import { reducer, initialState } from './reducer';
import { windowConfigActions } from './actions';
export var WindowConfigContext = createContext(undefined);
export var WindowConfigProvider = function WindowConfigProvider(_ref) {
  var mobileQuery = _ref.mobileQuery,
      children = _ref.children;

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  useEffect(function () {
    var active = true;
    var query = window.matchMedia(mobileQuery);

    var handler = function handler() {
      if (active) {
        var viewportWidth = getViewportWidth();
        dispatch(windowConfigActions.adjustViewport(viewportWidth, query.matches));
      }
    };

    handler();
    query.addListener(handler);
    return function () {
      active = false;
      query.removeListener(handler);
    };
  }, [mobileQuery]);
  return React.createElement(WindowConfigContext.Provider, {
    value: state
  }, children);
};
WindowConfigProvider.defaultProps = {
  mobileQuery: '(max-width: 599px)'
};